angular.module("vgresiduos").factory("ibamaService", [
	"$http",
	"$q",
	"localStorageWithTimeoutService",
	function ($http, $q, localStorageWithTimeoutService) {
		"use strict";

		const cacheTimeoutInMinutes = 43200;

		const _listIbamaResidues = function (params) {
			let parameters = "";
			if (params) {
				parameters = $.param(params);
			}

			const req = {
				method: "get",
				url: Vgr.constants.residuesHostUrl + Vgr.resources.residues.ibamaResidues + "?" + parameters
			};
			return $http(req);
		};

		const _listIbamaActivities = function () {
			return Vgr.util.getWithCache(
				Vgr.constants.coreHostUrl + Vgr.resources.core.ibamaActivities,
				null,
				Vgr.constants.cacheKeysPrefix.ibamaActivities,
				cacheTimeoutInMinutes,
				localStorageWithTimeoutService,
				$http,
				$q
			);
		};

		return {
			listIbamaResidues: _listIbamaResidues,
			listIbamaActivities: _listIbamaActivities
		};
	}
]);
